import PageHero from '../components/PageHero.jsx';

export default function FAQ() {
  return (
    <div>
      <PageHero icon="./assets/eagle/page-icons/faq.png" title="FAQ" />
    </div>
  );
}
